<script>
import { getCountryByIso } from '../lib/api';

export default {
  name: 'Worker',
  props: {
    value: Object,
    countries: Array,
    showRemove: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      jobs: [],
      job_code: '',
      iso_code: '',
      hours: 1
    };
  },
  async created() {
    this.iso_code = this.value.iso_code;
    this.hours = this.value.hours;
    await this.onWorkerCountryChange();
  },
  watch: {
    job_code() {
      this.onChange();
    },
    hours() {
      this.onChange();
    }
  },
  computed: {
    worker() {
      return {
        id: this.value.id,
        iso_code: this.iso_code,
        job_code: this.job_code,
        hours: this.hours
      };
    }
  },
  methods: {
    onRemove() {
      this.$emit('remove', this.worker.id);
    },
    onChange() {
      this.$emit('change', this.worker);
    },
    async onWorkerCountryChange() {
      const country = await getCountryByIso(this.iso_code);
      if (country) {
        this.iso_code = country.iso_code;
        this.job_code = country.job_default;
        this.jobs = country.jobs;
        this.onChange();
      }
    }
  }
};
</script>

<template>
  <div class="row">
    <div class="col-md-3 mb-3">
      <label for="role">Country</label>
      <select
        class="custom-select d-block w-100"
        v-model="iso_code"
        required
        placeholder="Select Country"
        @change="onWorkerCountryChange()"
      >
        <option
          v-for="(country, index) in countries"
          :key="index"
          :value="country.iso_code"
        >{{country.name}}</option>
      </select>
      <div class="invalid-feedback">Please select a valid country.</div>
    </div>

    <div class="col-md-5 mb-3">
      <label for="role">Job Title</label>
      <select
        class="custom-select d-block w-100"
        v-model="job_code"
        required
        placeholder="Select Job title"
      >
        <option v-for="(job, index) in jobs" :key="index" :value="job.code">{{job.title}}</option>
      </select>
      <div class="invalid-feedback">Please select a valid role.</div>
    </div>

    <div class="col-md-3 mb-3">
      <label for="hours">Hours Spent</label>
      <input type="number" class="form-control" id="hours" placeholder="1.5" v-model="hours" />
      <div class="invalid-feedback">Please enter a valid email address for shipping updates.</div>
    </div>
    <div class="col-md-1 mb-3" v-if="showRemove">
      <hr class="mb-3" />
      <button
        type="button"
        class="form-control btn btn-outline-danger"
        @click.prevent="onRemove()"
      >X</button>
    </div>
  </div>
</template>